<template>
  <div class="content">
    <base-header class="pb-6">
      <div class="row align-items-center py-4">
        <div class="col-lg-6 col-7">
          <h6 class="h2 text-white d-inline-block mb-0">
            {{ $t("wms.menu.product") }}
          </h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </div>

      </div>
    </base-header>
    <div class="container-fluid mt--6">
      <div>
        <card
          class="no-border-card"
          body-classes="px-0 pb-1"
          footer-classes="pb-2"
        >
          <template slot="header">
             <div class="row">
 <base-input
                  v-model="SearchKeyword"
                  prepend-icon="fas fa-search"
                  :placeholder="$t('search')"
                >
                </base-input>

                <div class="col-md-1">
                 <base-button
                  size="md"
                  type="neutral"
                  @click="ProductExport()"
                >
                  Export
                </base-button>
              </div>
             </div>
          </template>
          <div>
            <el-table
              :data="queriedData"
              row-key="id"
              header-row-class-name="thead-light"
            >
				

              <el-table-column
                v-for="column in tableColumns"
                :key="column.label"
                v-bind="column"
              >
              </el-table-column>

             
            </el-table>
          </div>
          <div
            slot="footer"
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
            v-if="queriedData.length != 0"
          >
            <div class="">
              <p class="card-category">
                {{ $t("data") }} {{ from + 1 }} {{ $t("to") }} {{ to }}
                {{ $t("of") }}
                {{ total }}
                <span v-if="selectedRows.length">
                  - &nbsp; &nbsp; {{ selectedRows.length }}
                  {{ $t("row_select") }}
                </span>
              </p>
            </div>
            <base-pagination
              class="pagination-no-border"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="total"
            >
            </base-pagination>
          </div>
        </card>
      </div>
    </div>

    <modal :show.sync="showAddModal" modal-classes="modal-secondary">
      <form class="new-event--form" @submit.prevent="saveEvent">
        <base-input
          :label="$t('wms.product_name')"
          v-model="md.name"
          input-classes="form-control-alternative new-event--title"
        >
        </base-input>

        <base-input
          :label="$t('wms.product_pn')"
          v-model="md.part_number"
          input-classes="form-control-alternative new-event--title"
        >
        </base-input>

        <base-input
          :label="$t('wms.barcode')"
          v-model="md.barcode"
          input-classes="form-control-alternative new-event--title"
        >
        </base-input>

		<div class="row">
			<div class="col-md-3">
				<base-input :label="$t('wms.width')" v-model="md.width"/>
			</div>
			<div class="col-md-3">
				<base-input :label="$t('wms.height')" v-model="md.height"/>
			</div>
			<div class="col-md-3">
				<base-input :label="$t('wms.depth')" v-model="md.depth"/>
			</div>
			<div class="col-md-3">
				<base-input :label="$t('wms.weight')" v-model="md.weight"/>
			</div>
		</div>

		<div class="row">
			<div class="col-md-6">
				<base-input :label="$t('image')" :name="$t('image')" >
					<file-input rules="required" @change="filesChange" ref="fileImage"></file-input>
				</base-input>
			</div>
			<div class="col-md-6">
				<img :src="GetProductUrl(md.image)" height="200px" v-if="md.image.includes('.png') || md.image.includes('.jpg') || md.image.includes('jpeg')"/>
				<img v-if="!md.image.includes('.png') && !md.image.includes('.jpg') && !md.image.includes('jpeg')  && md.image != '' && md.image != null && md.image!= undefined " :src="md.image" height="200px" />
			</div>
		</div>

        <input type="hidden" class="new-event--start" />
        <input type="hidden" class="new-event--end" />
      </form>

      <template slot="footer">
        <button
          type="submit"
          class="btn btn-md btn-primary"
          @click="handleUpdate()"
        >
          {{ $t("save") }}
        </button>
        <button
          type="button"
          class="btn btn-md btn-link ml-auto"
          @click="showAddModal = false"
        >
          {{ $t("close") }}
        </button>
      </template>
    </modal>
  </div>
</template>
<script>
import { Table, TableColumn, Select, Option } from "element-ui";
import FileInput from "@/components/Inputs/FileInput";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import { BasePagination } from "@/components";
import clientPaginationMixin from "./PaginatedTables/clientPaginationMixin";
import swal from "sweetalert2";
import { mapGetters, mapActions } from "vuex";
import { read, utils, writeFile } from 'xlsx'

export default {
  mixins: [clientPaginationMixin],
  components: {
    BasePagination,
    RouteBreadCrumb,
	FileInput,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
  },
  computed: {
    ...mapGetters({
      tableDataOrg: "WmsProduct/getDataWaitShip",
    }),
    tableData: function () {
      let data =  this.tableDataOrg;
      if (this.SearchKeyword != "") {
		data = this.tableDataOrg.filter((d) => {
          return d.wms_product_name.toLowerCase().indexOf(this.SearchKeyword.toLowerCase()) != -1 
        });
      } 


	  data.sort((a, b) => {
			if (b.pickup_quantity < a.pickup_quantity) return -1;
			if (b.pickup_quantity > a.pickup_quantity) return 1;
			return 0
	  })

	  return data

    },
    tableColumns: function () {
      return [
        {
          prop: "wms_product_name",
          label: this.$t("wms.product_name"),
          minWidth: 90,
          sortable: true,
        },
        {
          prop: "barcode",
          label: this.$t("wms.barcode"),
          minWidth: 90,
        },
        {
          prop: "pickup_quantity",
          label: this.$t("wms.amount"),
          minWidth: 90,
        },
      ];
    },
  },
  data() {
    return {
      propsToSearch: ["Name", "BarCode"],
      selectedRows: [],
      showAddModal: false,
      SearchKeyword: "",
      md: {
        id: 0,
        name: "",
        partner_id: "",
        part_number: "",
        barcode: "",
        width: 0,
        height: 0,
        depth: 0,
        weight: 0,
		image:"",
      },
      partner: [{ label: "MadameFin", value: 1 }],
    };
  },
  mounted() {
    this.listData({time_days : 2});
  },
  methods: {
    ...mapActions({
      listData: "WmsProduct/listWaitShipData",
    }),

    ProductExport() {
      let dataExport = this.tableData

      const dataWS = utils.json_to_sheet(dataExport)
			const wb = utils.book_new()
			utils.book_append_sheet(wb, dataWS)
			writeFile(wb,'สินค้ารอส่ง.xlsx')
    },
    handleCreate() {
      this.showAddModal = true;
      this.md.id = 0;
      this.md.part_number = "";
      this.md.name = "";
      this.md.barcode = "";
      this.md.width = 0;
      this.md.height = 0;
      this.md.depth = 0;
      this.md.weight = 0;
	  this.md.image = "";
    },
	handleBarcode(index,row){
		console.log(row)
		this.getBarcode({
          barcode: row.BarCode,
          type: "base64",
        })
          .then((resp) => {
            console.log(resp.data)
			swal.fire({
  title: row.Name,
  html: '<img src="'+resp.data+'">' + row.BarCode,
  showCloseButton: false,
  showCancelButton: false,
  focusConfirm: false,
  confirmButtonText:
    'Close',
  confirmButtonAriaLabel: 'Thumbs up, great!',

})
          })
          .catch((err) => {
            swal.fire({
              title: "สร้าง Barcode ผิดพลาด",
              text: "Barcode : " + row.BarCode,
              icon: "error",
              confirmButtonClass: "btn btn-danger btn-fill",
              buttonsStyling: false,
            });
          });

	},
    handleEdit(index, row) {
      this.showAddModal = true;
      this.md.id = row.ID;
      this.md.partner_id = row.PartnerID;
      this.md.part_number = row.ManPN;
      this.md.name = row.Name;
      this.md.barcode = row.BarCode;
      this.md.width = row.SizeWidth;
      this.md.height = row.SizeHeight;
      this.md.depth = row.SizeDepth;
      this.md.weight = row.Weight;
	  this.md.image = row.Image == null ? "": row.Image;
	  this.$refs.fileImage.clearFile()
	},
    handleUpdate() {
      this.showAddModal = false;

      if (this.md.id == 0) {
        // create
        this.createData({
          Name: this.md.name,
          ManPN: this.md.part_number,
          PartnerID: this.md.partner_id,
          SizeHeight: parseInt(this.md.height),
          SizeDepth: parseInt(this.md.depth),
          SizeWidth: parseInt(this.md.width),
          Weight: parseInt(this.md.weight),
          BarCode: this.md.barcode,
		  Image : this.md.image
        })
          .then((resp) => {
            this.listData();
            swal.fire({
              title: this.$t("create_success"),
              text: ``,
              icon: "success",
              confirmButtonClass: "btn btn-success btn-fill",
              buttonsStyling: false,
            });
          })
          .catch((err) => {
            swal.fire({
              title: this.$t(err.response.data.Msg),
              text: this.getErrorText(err.response.data),
              icon: "error",
              confirmButtonClass: "btn btn-danger btn-fill",
              buttonsStyling: false,
            });
          });
      } else {
        // update

        this.updateData( {
          id: this.md.id,
		  payload : {
          Name: this.md.name,
          ManPN: this.md.part_number,
          PartnerID: this.md.partner_id,
          SizeHeight: parseInt(this.md.height),
          SizeDepth: parseInt(this.md.depth),
          SizeWidth: parseInt(this.md.width),
          Weight: parseInt(this.md.weight),
          BarCode: this.md.barcode,
		  Image : this.fileNameIsImage(this.md.image) ? "": this.md.image ,
		  }
        })
          .then((resp) => {
            this.listData();
            swal.fire({
              title: this.$t("edit_success"),
              text: ``,
              icon: "success",
              confirmButtonClass: "btn btn-success btn-fill",
              buttonsStyling: false,
            });
          })
          .catch((err) => {
            swal.fire({
              title: this.$t(err.response.data.Msg),
              text: this.getErrorText(err.response.data),
              icon: "error",
              confirmButtonClass: "btn btn-danger btn-fill",
              buttonsStyling: false,
            });
          });
      }
    },
    handleDelete(index, row) {
      swal
        .fire({
          title: this.$t("delete_confirm"),
          text: this.$t("delete_confirm_question") + row.Name,
          icon: "warning",
          showCancelButton: true,
          confirmButtonClass: "btn btn-success btn-fill",
          cancelButtonClass: "btn btn-danger btn-fill",
          confirmButtonText: this.$t("confirm"),
          cancelButtonText: this.$t("cancel"),
          buttonsStyling: false,
        })
        .then((result) => {
          if (result.value) {
            this.deleteData(row.ID)
              .then((resp) => {
                this.listData();
                swal.fire({
                  title: this.$t("delete_success"),
                  text: ``,
                  icon: "success",
                  confirmButtonClass: "btn btn-success btn-fill",
                  buttonsStyling: false,
                });
              })
              .catch((err) => {
                swal.fire({
                  title: this.$t(err.response.data.Msg),
                  text: this.getErrorText(err.response.data),
                  icon: "error",
                  confirmButtonClass: "btn btn-danger btn-fill",
                  buttonsStyling: false,
                });
              });
          }
        });
    },
	filesChange(files) {
		if (files[0].type != "image/png" && files[0].type != "image/jpeg") {
			swal.fire({
				title: "Error",
				text: "กรุณาเลือกไฟล์รูปภาพ",
				icon: "error",
				confirmButtonClass: "btn btn-danger btn-fill",
				buttonsStyling: false
			});

			this.$refs.fileImage.clearFile();
			return;
		}


		if (files[0].size > 1024 * 1024 *2) {
			swal.fire({
				title: "Error",
				text: "ขนาดไฟล์รูปภาพต้องไม่เกิน 2 MB",
				icon: "error",
				confirmButtonClass: "btn btn-danger btn-fill",
				buttonsStyling: false
			});
			this.$refs.fileImage.clearFile();
			return;
		}

		const reader = new FileReader();
		reader.readAsDataURL(files[0]);
		reader.onload = () => {
			this.md.image = reader.result;
		};
	},

	GetProductUrl(filename){
		console.log("FileName " + filename)
		return process.env.VUE_APP_API_BASE_URL + "/files/wms_products/" + filename
	},
	fileNameIsImage(filename) {
		return filename.includes(".png") || filename.includes(".jpg") || filename.includes(".jpeg")
	}
},
};
</script>
<style>
.no-border-card .card-footer {
  border-top: 0;
}
</style>
